import React, { FC, useRef, useEffect } from "react";
import { sortCustomersData } from "@sdge-store/customers/customers.async";
import { handleSort } from "@sdge-store/customers/customers.slice";
import { useAppSelector } from "../../app/hooks";
import { SelectSort, SortOptionsItem } from "./components";
import { Styled } from "./SortOptionsMenu.styled";
import { selectCustomers } from "@sdge-store/customers/customers.selector";

const CustomersSortOptionsMenu: FC = () => {
  const { sort, columnDefs, filteringRules, searchInputValue } =
    useAppSelector(selectCustomers);
  const listEnd = useRef<any>();

  const scrollToBottom = () => {
    listEnd.current.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(scrollToBottom, [sort.length]);
  const unsortedCols = (columnDefs as any[])
    .filter(({ headerName }) => headerName)
    .filter(({ sorting }) => sorting)
    .filter((o1) => !sort.some((o2: any) => o1.field === o2.property));
  const sortingCols = unsortedCols
    .map((item, index) => {
      return {
        id: index,
        value: item.sortField || item.field,
        label: item.headerName,
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));

  return (
    <Styled.SortOptionsWrapper>
      <Styled.SortOptionsList>
        {(sort as any[]).map((item, index) => (
          <SortOptionsItem
            key={item.property}
            field={item.property}
            order={item.direction}
            index={index}
            columnDefs={columnDefs}
            sort={sort}
            filteringRules={filteringRules}
            searchInputValue={searchInputValue}
            handleSort={handleSort}
            sortData={sortCustomersData}
          />
        ))}
        <Styled.ListBottom ref={listEnd}></Styled.ListBottom>
      </Styled.SortOptionsList>
      <Styled.SelectSortWrapper>
        {sortingCols.length > 0 && (
          <SelectSort
            placeHolder="Add field to sort by"
            optionsData={sortingCols}
            order="ASC"
            sort={sort}
            filteringRules={filteringRules}
            searchInputValue={searchInputValue}
            handleSort={handleSort}
            sortData={sortCustomersData}
          />
        )}
      </Styled.SelectSortWrapper>
    </Styled.SortOptionsWrapper>
  );
};

export default CustomersSortOptionsMenu;
